import {
  Drawer,
  DrawerBody,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";

export interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  placement?: "top" | "right" | "bottom" | "left";
  title?: string;
  children: React.ReactNode;
  size?: string;
  key?: string;
}

function BaseDrawer({
  isOpen,
  onClose,
  placement = "right",
  title,
  children,
  size = "sm",
  key,
}: DrawerProps) {
  return (
    <Drawer
      key={key || "drawer"}
      isOpen={isOpen}
      placement={placement}
      onClose={onClose}
      size={size}
    >
      <DrawerOverlay />
      <DrawerContent key={`${key}-drawer-content`}>
        <DrawerCloseButton
          top="14px"
          right="16px"
          color="#646B78"
          _hover={{ bg: '#F5F6F8', color: '#14171C' }}
          borderRadius="6px"
          size="sm"
        />
        {title && (
          <DrawerHeader
            px="20px"
            py="16px"
            fontSize="14px"
            fontWeight="600"
            color="#14171C"
            borderBottom="1px solid #E7E9EE"
            pr="40px"
          >
            {title}
          </DrawerHeader>
        )}
        <DrawerBody key={`${key}-drawer-body`} px="20px" py="20px">
          {children}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}

export default BaseDrawer;
